import { ApiService } from '@/axios'


export const getCategorias = (query) => {
    return ApiService.get(`categorias/?${query}`)
}